import React, { useState, useEffect } from 'react';
import { CombustibleService } from '../services/combustibleService';
import { AutosService } from '../services/autosService';
import { ChoferesService } from '../services/choferesService';
import './GestionCombustible.css';

const GestionCombustible = () => {
  console.log('GestionCombustible component loaded with new button');
  const [registros, setRegistros] = useState([]);
  const [vehiculos, setVehiculos] = useState([]);
  const [choferes, setChoferes] = useState([]);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [areaVehicularFiltro, setAreaVehicularFiltro] = useState(''); // '', 'reparto', 'proveedor', 'empleado'
  const [formulario, setFormulario] = useState({
    fecha: '',
    tipoGasolina: '',
    vehiculo: '',
    kilometrajeInicial: '',
    kilometrajeFinal: '',
    litrosConsumidos: '',
    monto: '',
    numeroTicket: ''
  });
  const [filtros, setFiltros] = useState({
    fechaInicio: '',
    areaVehicular: '',
    vehiculo: '',
    chofer: ''
  });
  const [estadisticas, setEstadisticas] = useState({
    rendimientoPromedio: 0,
    gastoTotal: 0,
    kilometrosTotales: 0,
    alertas: []
  });

  useEffect(() => {
    const unsubscribeRegistros = CombustibleService.suscribirseRegistros(setRegistros);
    const unsubscribeAutos = AutosService.suscribirseAutos(setVehiculos);
    const unsubscribeChoferes = ChoferesService.suscribirseChoferes(setChoferes);

    return () => {
      unsubscribeRegistros();
      if (typeof unsubscribeAutos === 'function') unsubscribeAutos();
      if (typeof unsubscribeChoferes === 'function') unsubscribeChoferes();
    };
  }, []);

  useEffect(() => {
    calcularEstadisticas();
  }, [registros]);

  const calcularEstadisticas = () => {
    if (registros.length === 0) return;

    console.log('Registros recibidos:', registros);

    const rendimientos = registros
      .filter(reg => {
        const tieneDatos = reg.kilometrajeFinal && reg.kilometrajeInicial && reg.litrosConsumidos;
        console.log('Registro filtrado:', reg, 'Tiene datos:', tieneDatos);
        return tieneDatos;
      })
      .map(reg => {
        const kmRecorridos = reg.kilometrajeFinal - reg.kilometrajeInicial;
        const rendimiento = kmRecorridos / reg.litrosConsumidos;
        console.log('Cálculo rendimiento:', {
          kmInicial: reg.kilometrajeInicial,
          kmFinal: reg.kilometrajeFinal,
          kmRecorridos,
          litros: reg.litrosConsumidos,
          rendimiento
        });
        return rendimiento;
      });

    console.log('Rendimientos calculados:', rendimientos);

    if (rendimientos.length === 0) {
      setEstadisticas({
        rendimientoPromedio: 0,
        gastoTotal: 0,
        kilometrosTotales: 0,
        alertas: []
      });
      return;
    }

    const rendimientoPromedio = rendimientos.reduce((a, b) => a + b, 0) / rendimientos.length;
    const gastoTotal = registros.reduce((sum, reg) => sum + (reg.monto || 0), 0);
    const kilometrosTotales = registros.reduce((sum, reg) => {
      if (reg.kilometrajeFinal && reg.kilometrajeInicial) {
        return sum + (reg.kilometrajeFinal - reg.kilometrajeInicial);
      }
      return sum;
    }, 0);

    console.log('Estadísticas calculadas:', {
      rendimientoPromedio,
      gastoTotal,
      kilometrosTotales
    });

    // Generar alertas inteligentes
    const alertas = generarAlertas(registros, rendimientoPromedio);

    setEstadisticas({
      rendimientoPromedio: Math.round(rendimientoPromedio * 100) / 100,
      gastoTotal,
      kilometrosTotales,
      alertas
    });
  };

  const generarAlertas = (registros, rendimientoPromedio) => {
    const alertas = [];
    
    if (rendimientoPromedio === 0) return alertas;
    
    // Agrupar por vehículo para análisis
    const porVehiculo = registros
      .filter(reg => reg.vehiculo && reg.kilometrajeFinal && reg.kilometrajeInicial && reg.litrosConsumidos)
      .reduce((acc, reg) => {
        if (!acc[reg.vehiculo]) acc[reg.vehiculo] = [];
        acc[reg.vehiculo].push(reg);
        return acc;
      }, {});

    Object.entries(porVehiculo).forEach(([vehiculo, regs]) => {
      const rendimientoVehiculo = regs.map(reg => {
        const km = reg.kilometrajeFinal - reg.kilometrajeInicial;
        return km / reg.litrosConsumidos;
      });
      
      const rendimientoPromedioVehiculo = rendimientoVehiculo.reduce((a, b) => a + b, 0) / rendimientoVehiculo.length;
      const diferencia = ((rendimientoPromedioVehiculo - rendimientoPromedio) / rendimientoPromedio) * 100;

      if (diferencia < -15) {
        alertas.push({
          tipo: 'warning',
          mensaje: `El vehículo ${vehiculo} está consumiendo un ${Math.abs(diferencia).toFixed(1)}% más que el promedio`
        });
      }
    });

    return alertas;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormulario(prev => ({ ...prev, [name]: value }));
    
    // Calcular automáticamente el rendimiento si tenemos los datos necesarios
    if (name === 'kilometrajeFinal' && formulario.kilometrajeInicial && formulario.litrosConsumidos) {
      const kmRecorridos = parseFloat(value) - parseFloat(formulario.kilometrajeInicial);
      const rendimiento = kmRecorridos / parseFloat(formulario.litrosConsumidos);
      console.log(`Rendimiento calculado: ${rendimiento.toFixed(2)} km/l`);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validar que todos los campos numéricos estén presentes
    if (!formulario.kilometrajeInicial || !formulario.kilometrajeFinal || !formulario.litrosConsumidos || !formulario.monto) {
      alert('Todos los campos son obligatorios');
      return;
    }
    
    const kmInicial = parseFloat(formulario.kilometrajeInicial);
    const kmFinal = parseFloat(formulario.kilometrajeFinal);
    const litros = parseFloat(formulario.litrosConsumidos);
    const monto = parseFloat(formulario.monto);
    
    if (kmFinal <= kmInicial) {
      alert('El kilometraje final debe ser mayor al inicial');
      return;
    }
    
    if (litros <= 0) {
      alert('Los litros consumidos deben ser mayor a 0');
      return;
    }
    
    if (monto <= 0) {
      alert('El monto debe ser mayor a 0');
      return;
    }

    try {
      const kmRecorridos = kmFinal - kmInicial;
      const rendimiento = kmRecorridos / litros;
      
      console.log('Datos a guardar:', {
        kmInicial,
        kmFinal,
        kmRecorridos,
        litros,
        rendimiento,
        monto
      });
      
      await CombustibleService.crearRegistro({
        ...formulario,
        kilometrajeInicial: kmInicial,
        kilometrajeFinal: kmFinal,
        kilometrosRecorridos: kmRecorridos,
        litrosConsumidos: litros,
        rendimiento: Math.round(rendimiento * 100) / 100,
        monto: monto,
        fechaCreacion: new Date().toISOString()
      });

      alert('Registro de combustible guardado exitosamente');
      setFormulario({
        fecha: '',
        tipoGasolina: '',
        vehiculo: '',
        kilometrajeInicial: '',
        kilometrajeFinal: '',
        litrosConsumidos: '',
        monto: '',
        numeroTicket: ''
      });
      setMostrarModal(false);
    } catch (error) {
      console.error('Error al guardar:', error);
      alert('Error al guardar el registro');
    }
  };

  const exportarPDF = () => {
    CombustibleService.exportarPDF(registrosFiltrados);
  };

  // Utilidades para exportación Excel (CSV compatible con Excel)
  const toCSV = (rows) => {
    const escape = (val) => {
      if (val === null || val === undefined) return '';
      const s = String(val);
      if (s.includes(',') || s.includes('\n') || s.includes('"')) {
        return '"' + s.replace(/"/g, '""') + '"';
      }
      return s;
    };
    return rows.map(r => r.map(escape).join(',')).join('\n');
  };

  const descargarArchivo = (contenido, nombre, mime) => {
    const blob = new Blob([contenido], { type: mime });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = nombre;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  const formatearFecha = (f) => {
    try { return new Date(f).toISOString().slice(0,10); } catch { return f || ''; }
  };

  const construirFilasExport = (regs) => {
    const encabezados = [
      'Fecha', 'Área', 'Vehículo', 'Km Inicial', 'Km Final', 'Km Recorridos',
      'Litros', 'Rendimiento (km/l)', 'Monto', 'Número Ticket'
    ];
    const filas = regs.map(reg => {
      const veh = vehiculos.find(v => getVehiculoLabel(v) === reg.vehiculo);
      const area = veh?.areaVehicular || '';
      return [
        formatearFecha(reg.fecha || reg.fechaCreacion),
        area,
        reg.vehiculo || '',
        reg.kilometrajeInicial ?? '',
        reg.kilometrajeFinal ?? '',
        reg.kilometrosRecorridos ?? '',
        reg.litrosConsumidos ?? '',
        reg.rendimiento ?? '',
        reg.monto ?? '',
        reg.numeroTicket ?? ''
      ];
    });
    return [encabezados, ...filas];
  };

  const exportarExcelFiltrado = () => {
    const rows = construirFilasExport(registrosFiltrados);
    const csv = toCSV(rows);
    const nombre = `combustible_filtrado_${new Date().toISOString().slice(0,10)}.csv`;
    descargarArchivo(csv, nombre, 'text/csv;charset=utf-8');
  };

  const exportarExcelTodo = () => {
    const rows = construirFilasExport(registros);
    const csv = toCSV(rows);
    const nombre = `combustible_todo_${new Date().toISOString().slice(0,10)}.csv`;
    descargarArchivo(csv, nombre, 'text/csv;charset=utf-8');
  };

  const getRendimientoColor = (rendimiento) => {
    if (rendimiento >= 15) return 'eficiente';
    if (rendimiento >= 10) return 'promedio';
    return 'gasto';
  };

  const getRankingChoferes = () => {
    const porChofer = registros
      .filter(reg => reg.chofer && reg.rendimiento !== undefined)
      .reduce((acc, reg) => {
        if (!acc[reg.chofer]) acc[reg.chofer] = { total: 0, rendimientos: [] };
        acc[reg.chofer].total += reg.rendimiento;
        acc[reg.chofer].rendimientos.push(reg.rendimiento);
        return acc;
      }, {});

    return Object.entries(porChofer)
      .map(([chofer, data]) => ({
        chofer,
        rendimientoPromedio: data.total / data.rendimientos.length,
        totalRegistros: data.rendimientos.length
      }))
      .sort((a, b) => b.rendimientoPromedio - a.rendimientoPromedio)
      .slice(0, 5);
  };

  const getRankingVehiculos = () => {
    const porVehiculo = registros
      .filter(reg => reg.vehiculo && reg.rendimiento !== undefined)
      .reduce((acc, reg) => {
        if (!acc[reg.vehiculo]) acc[reg.vehiculo] = { total: 0, rendimientos: [] };
        acc[reg.vehiculo].total += reg.rendimiento;
        acc[reg.vehiculo].rendimientos.push(reg.rendimiento);
        return acc;
      }, {});

    return Object.entries(porVehiculo)
      .map(([vehiculo, data]) => ({
        vehiculo,
        rendimientoPromedio: data.total / data.rendimientos.length,
        totalRegistros: data.rendimientos.length
      }))
      .sort((a, b) => b.rendimientoPromedio - a.rendimientoPromedio)
      .slice(0, 5);
  };

  const getVehiculoLabel = (v) => {
    if (!v) return '';
    let label = v.placas ? `${v.placas} - ${v.marca || ''} ${v.modelo || ''}`.trim() : (v.nombre || v.id);
    if (v.areaVehicular === 'proveedor') label = `${v.nombreProveedor || 'Proveedor'} (${v.telefonoProveedor || '—'})`;
    if (v.areaVehicular === 'empleado') label = `${v.nombreEmpleado || 'Empleado'} (${v.numeroEmpleado || '—'})`;
    return label;
  };

  const registrosFiltrados = registros.filter(reg => {
    if (filtros.fechaInicio && reg.fecha < filtros.fechaInicio) return false;
    if (filtros.vehiculo && reg.vehiculo !== filtros.vehiculo) return false;
    if (filtros.chofer && reg.chofer !== filtros.chofer) return false;
    if (filtros.areaVehicular) {
      const veh = vehiculos.find(v => getVehiculoLabel(v) === reg.vehiculo);
      if (!veh || veh.areaVehicular !== filtros.areaVehicular) return false;
    }
    return true;
  });

  return (
    <div className="gestion-combustible">
      {/* Header */}
      <div className="header-section">
        <h1>Gestión de Combustible</h1>
        <button 
          className="btn-registrar"
          onClick={() => setMostrarModal(true)}
        >
          + Registrar Combustible
        </button>
      </div>

      {/* Panel de indicadores visuales */}
      <div className="indicadores-section">
        <h2>Indicadores de Rendimiento</h2>
        <div className="indicadores-grid">
          <div className="indicador-card">
            <h3>Semáforos de Rendimiento</h3>
            <div className="semaforos">
              <div className="semaforo-item">
                <span className="semaforo-label eficiente">Eficiente (≥15 km/l)</span>
              </div>
              <div className="semaforo-item">
                <span className="semaforo-label promedio">Promedio (10-15 km/l)</span>
              </div>
              <div className="semaforo-item">
                <span className="semaforo-label gasto">Gasto Excesivo (&lt;10 km/l)</span>
              </div>
            </div>
          </div>


          <div className="indicador-card">
            <h3>Ranking de Vehículos</h3>
            <div className="ranking-list">
              {getRankingVehiculos().map((item, index) => (
                <div key={item.vehiculo} className="ranking-item">
                  <span className="ranking-position">#{index + 1}</span>
                  <span className="ranking-name">{item.vehiculo}</span>
                  <span className={`ranking-value ${getRendimientoColor(item.rendimientoPromedio)}`}>
                    {item.rendimientoPromedio.toFixed(1)} km/l
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>


      {/* Alertas inteligentes */}
      {estadisticas.alertas.length > 0 && (
        <div className="alertas-section">
          <h2>Alertas Inteligentes</h2>
          <div className="alertas-grid">
              {estadisticas.alertas.map((alerta, index) => (
              <div key={index} className={`alerta-item ${alerta.tipo}`}>
                <span className="alerta-mensaje">{alerta.mensaje}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Filtros */}
      <div className="filtros-section">
        <h2>Filtros de Búsqueda</h2>
        <div className="filtros-grid">
          <div className="filter-group">
            <label>Fecha Inicio:</label>
            <input 
              type="date"
              value={filtros.fechaInicio}
              onChange={(e) => setFiltros({...filtros, fechaInicio: e.target.value})}
            />
          </div>
          <div className="filter-group">
            <label>Área vehicular:</label>
            <select
              value={filtros.areaVehicular}
              onChange={(e) => setFiltros({ ...filtros, areaVehicular: e.target.value })}
            >
              <option value="">Todas</option>
              <option value="reparto">Unidades de reparto</option>
              <option value="proveedor">Proveedores</option>
              <option value="empleado">Empleados</option>
            </select>
          </div>
          <div className="filter-group">
            <label>Vehículo:</label>
            <select 
              value={filtros.vehiculo}
              onChange={(e) => setFiltros({...filtros, vehiculo: e.target.value})}
            >
              <option value="">Todos los vehículos</option>
              {vehiculos.map(vehiculo => (
                <option key={vehiculo.id} value={`${vehiculo.placas} - ${vehiculo.marca} ${vehiculo.modelo}`}>
                  {vehiculo.placas} - {vehiculo.marca} {vehiculo.modelo}
                </option>
              ))}
            </select>
          </div>
          <div className="filter-group">
            <label>Chofer:</label>
            <select 
              value={filtros.chofer}
              onChange={(e) => setFiltros({...filtros, chofer: e.target.value})}
            >
              <option value="">Todos los choferes</option>
              {choferes.map(chofer => (
                <option key={chofer.id} value={chofer.nombre}>
                  {chofer.nombre}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Tabla de registros (restaurada) */}
      <div className="registros-section">
        <div className="section-header">
          <h2>Registros de Combustible ({registrosFiltrados.length})</h2>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn-exportar" onClick={exportarExcelFiltrado}>Exportar Excel (vista)</button>
            <button className="btn-exportar" onClick={exportarExcelTodo}>Exportar Excel (todo)</button>
            <button className="btn-exportar" onClick={exportarPDF}>Exportar PDF</button>
          </div>
        </div>
        
        {registrosFiltrados.length === 0 ? (
          <div className="no-data">
            <p>No hay registros que coincidan con los filtros</p>
          </div>
        ) : (
          <div className="table-container">
            <table className="registros-table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Vehículo</th>
                  <th>Chofer</th>
                  <th>Km Inicial</th>
                  <th>Km Final</th>
                  <th>Km Recorridos</th>
                  <th>Litros</th>
                  <th>Rendimiento</th>
                  <th>Monto</th>
                  <th>Estado</th>
                  <th>Ticket</th>
                </tr>
              </thead>
              <tbody>
                {registrosFiltrados.map((registro) => (
                  <tr key={registro.id}>
                    <td>{registro.fecha ? new Date(registro.fecha).toLocaleDateString() : 'N/A'}</td>
                    <td>{registro.vehiculo || 'N/A'}</td>
                    <td>{registro.chofer || 'N/A'}</td>
                    <td>{registro.kilometrajeInicial ? registro.kilometrajeInicial.toLocaleString() : 'N/A'}</td>
                    <td>{registro.kilometrajeFinal ? registro.kilometrajeFinal.toLocaleString() : 'N/A'}</td>
                    <td>{registro.kilometrosRecorridos ? registro.kilometrosRecorridos.toLocaleString() : 'N/A'}</td>
                    <td>{registro.litrosConsumidos || 'N/A'}</td>
                    <td>
                      <span className={`rendimiento-cell ${getRendimientoColor(registro.rendimiento)}`}>
                        {registro.rendimiento || 0} km/l
                      </span>
                    </td>
                    <td>${registro.monto ? registro.monto.toLocaleString() : 'N/A'}</td>
                    <td>
                      <span className={`status-badge ${getRendimientoColor(registro.rendimiento)}`}>
                        {registro.rendimiento >= 15 ? 'Eficiente' : registro.rendimiento >= 10 ? 'Promedio' : 'Gasto Excesivo'}
                      </span>

                    </td> 
                    {/* AQUI AGREGAS EL TICKET */}
                      <td>{registro.ticket || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal de registro */}
      {mostrarModal && (
        <div className="modal-overlay" onClick={() => setMostrarModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Registrar Consumo de Combustible</h2>
              <button className="close-button" onClick={() => setMostrarModal(false)}>×</button>
            </div>
            <form className="form-combustible" onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label>Fecha *</label>
                  <input
                    type="date"
                    name="fecha"
                    value={formulario.fecha}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Tipo de gasolina *</label>
                  <select
                    name="tipoGasolina"
                    value={formulario.tipoGasolina}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Seleccionar...</option>
                    <option value="Magna">Magna</option>
                    <option value="Premium">Premium</option>
                    <option value="Diesel">Diesel</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Área vehicular</label>
                  <select
                    name="areaVehicular"
                    value={areaVehicularFiltro}
                    onChange={(e) => {
                      setAreaVehicularFiltro(e.target.value);
                      setFormulario(prev => ({ ...prev, vehiculo: '' }));
                    }}
                  >
                    <option value="">Todas</option>
                    <option value="reparto">Unidades de reparto</option>
                    <option value="proveedor">Proveedores</option>
                    <option value="empleado">Empleados</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Vehículo *</label>
                  <select
                    name="vehiculo"
                    value={formulario.vehiculo}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Seleccionar...</option>
                    {vehiculos
                      .filter(v => !areaVehicularFiltro || v.areaVehicular === areaVehicularFiltro)
                      .map(v => {
                        let label = v.placas ? `${v.placas} - ${v.marca || ''} ${v.modelo || ''}`.trim() : (v.nombre || v.id);
                        if (v.areaVehicular === 'proveedor') {
                          label = `${v.nombreProveedor || 'Proveedor'} (${v.telefonoProveedor || '—'})`;
                        }
                        if (v.areaVehicular === 'empleado') {
                          label = `${v.nombreEmpleado || 'Empleado'} (${v.numeroEmpleado || '—'})`;
                        }
                        return (
                          <option key={v.id} value={label}>{label}</option>
                        );
                      })}
                  </select>
                </div>
                {/* Campo Chofer eliminado por solicitud */}
                <div className="form-group">
                  <label>Kilometraje Inicial *</label>
                  <input
                    type="number"
                    name="kilometrajeInicial"
                    placeholder="0"
                    value={formulario.kilometrajeInicial}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Kilometraje Final *</label>
                  <input
                    type="number"
                    name="kilometrajeFinal"
                    placeholder="0"
                    value={formulario.kilometrajeFinal}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Litros recargados *</label>
                  <input
                    type="number"
                    step="0.01"
                    name="litrosConsumidos"
                    placeholder="Ej: 50.00"
                    value={formulario.litrosConsumidos}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Monto ($) *</label>
                  <input
                    type="number"
                    step="0.01"
                    name="monto"
                    placeholder="0.00"
                    value={formulario.monto}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Número de ticket *</label>
                  <input
                    type="text"
                    name="numeroTicket"
                    placeholder="Ej: TK-001234"
                    value={formulario.numeroTicket}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <div className="form-actions">
                <button type="button" className="btn-cancelar" onClick={() => setMostrarModal(false)}>
                  Cancelar
                </button>
                <button type="submit" className="btn-registrar">
                  Registrar Combustible
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default GestionCombustible;
